import { useEffect, useState } from "react";

import { useSelector } from "react-redux";

import AddIcon from "@mui/icons-material/Add";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import {
  Avatar,
  Box,
  CardContent,
  Chip,
  Fab,
  Grid,
  ListItemButton,
  Stack,
  Typography
} from "@mui/material";
import dayjs from "dayjs";
import InfiniteScroll from "react-infinite-scroll-component";

import { useLocation } from "react-router-dom";
import Loader from "../../common/Loader";
import { FETCH_CLIENT_SAFETY_OBSERVATION } from "../../constant/Apipath";
import { Postrequestcall } from "../../request/Postrequest";
import TabsComponent from "../component/TabsComponent";
import { ClientEnglishFallback } from "../constant/ClientEnglishFallback";
import ClientSafetyObservationAddModal from "./ClientSafetyObservationAddModal";
import { ClientSafetyObservationViewModal } from "./ClientSafetyObservationViewModal";

export default function SafetyObservation() {
  const { loginData, selectedClientData, multiLanguageData } = useSelector((state) => state?.main);
  const TOKEN = loginData?.accessToken;
  const CLIENT_ACCENT_COLOR = selectedClientData?.AccentColor;

  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [currentTab, setCurrentTab] = useState(0);
  const [isLoading, setLoading] = useState(false);
  const [addSafetyObservation, setAddSafetyObservation] = useState(false);
  const location = useLocation();
  const LANGUAGE = ClientEnglishFallback.SafetyObservations(
    multiLanguageData?.SafetyObservations || {}
  );
  const { TEXT_ALL, TEXT_MY_OBSERVATION, TEXT_NO_OBSERVATIONS } = LANGUAGE;
  useEffect(() => {
    if(currentTab == 0){
      fetchClientSafetyObs("true");
    }
  }, [location,currentTab]);

  const fetchClientSafetyObs = async (reLoadData) => {
    setLoading(true);
    let payload = {
      PageNr: reLoadData ? 1 : page,
      NrOfRecPerPage: 20,
      FullSearch: location?.state?.searchText || "",
      UserId: loginData?.userInformation?.UserId,
      IncludeRecordNr: true,
      FetchAllowedRecordsOnly: true,
      SortList: [
        {
          FieldName: "Id",
          Direction: "DESC"
        }
      ],
      SearchList: [{ clientId: selectedClientData?.ClientId }]
    };
    try {
      let response = await Postrequestcall(FETCH_CLIENT_SAFETY_OBSERVATION, payload, TOKEN);

      if (response?.data?.data?.length === 0) {
        setHasMore(false);
      }
      if (reLoadData) {
        setData(response?.data?.data || []);
        setPage(2);
      } else {
        setData([...(data || []), ...(response?.data?.data || [])]);
        setPage(page + 1);
      }
    } catch (error) {
      console.log("fetchClientSafetyObs-> Error Fetching Client Safety Observation: ", error);
    }finally{
      setLoading(false);
    }
  };

  const Tabs = [
    {
      label: "All",
      value: 0,
      translateLabel: TEXT_ALL
    },
    {
      label: "My Observations",
      value: 1,
      translateLabel: TEXT_MY_OBSERVATION
    }
  ];
  return (
    isLoading ? <Loader fullScreen={true} />:<>
      <Box>
        <Box>
          <TabsComponent tabs={Tabs} setTabsValue={setCurrentTab} tabValue={currentTab} />
        </Box>
        {!isLoading && data?.length === 0 && (
          <Stack sx={{ width: "100%", justifyContent: "center", alignItems: "center" }} height="85vh">
            <Typography>{TEXT_NO_OBSERVATIONS}</Typography>
          </Stack>
        )}

        {isLoading && data?.length === 0 ? (
          <Loader fullScreen={true} />
        ) : (
          <InfiniteScroll
            dataLength={data?.length}
            next={fetchClientSafetyObs}
            hasMore={hasMore}
            loader={<Loader />}>
            {data?.map((item, index) => {
              if (currentTab == 1) {
                if (selectedClientData?.ClientEmployeeId == item?.clientEmployeeId) {
                  return (
                    <CardComponent
                      reLoadData={() => fetchClientSafetyObs(true)}
                      index={index}
                      key={index}
                      data={item}
                      activeTab={1}
                    />
                  );
                }
              } else {
                return (
                  <CardComponent
                    reLoadData={() => fetchClientSafetyObs(true)}
                    key={index}
                    data={item}
                    activeTab={0}
                  />
                );
              }
            })}
          </InfiniteScroll>
        )}
      </Box>

      <Fab
        onClick={() => setAddSafetyObservation(true)}
        style={{
          position: "fixed",
          bottom: "20px",
          right: "20px"
        }}
        sx={{
          bgcolor: CLIENT_ACCENT_COLOR,
          "&:hover": {
            bgcolor: CLIENT_ACCENT_COLOR
          }
        }}
        aria-label="add">
        <AddIcon
          style={{
            color: "white"
          }}
        />
      </Fab>

      {addSafetyObservation && <ClientSafetyObservationAddModal
        reLoadData={() => fetchClientSafetyObs(true)}
        isOpen={addSafetyObservation}
        onClose={() => setAddSafetyObservation(false)}
        data={data}
        setData={setData}
        mode={"ADD"}
        from={"ADD"}
      />
      }
    </>
  );
}

const CardComponent = ({ data, activeTab, reLoadData, index }) => {
  const { selectedClientData } = useSelector((state) => state?.main);
  const CLIENT_ACCENT_COLOR = selectedClientData?.AccentColor;
  const [viewModal, setViewModel] = useState(false);

  return (
    <div key={index}>
      <Grid
        sx={{ padding: {
          xs: 0.2,
          sm: 0.5,
          md: 1,
          lg: 1,
          xl: 1
         }}}
        size={{
          xs: 12,
          sm: 12,
          md: 12,
          lg: 12,
          xl: 12
        }}>
        {activeTab === 1 ? (
          <>
            {selectedClientData?.ClientEmployeeId === data?.clientEmployeeId ? (
              <div
                style={{
                  backgroundColor: "white",
                  borderRadius: "10px"
                }}>
                <ListItemButton
                  style={{
                    borderRadius: "10px",
                    padding: "10px"
                  }}
                  onClick={() => setViewModel(true)}>
                  <CardContent
                    style={{
                      padding: "0px",
                      width: "100%"
                    }}>
                    <Stack sx={{ display: "flex",  justifyContent: "space-between", alignItems: "center" }}  direction={"row"}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: ".5rem"
                        }}>
                        <Grid>
                          <LocationOnIcon
                            style={{
                              color: CLIENT_ACCENT_COLOR
                            }}
                          />
                        </Grid>
                        <Grid>
                          <Typography variant="body2" sx={{ color: "text.secondary" }}>
                            {`${data?.clientJobCode} - ${data?.clientJobName}`}
                          </Typography>
                        </Grid>
                      </div>
                      <Typography
                        style={{
                          color: "grey"
                        }}
                        variant="body2">
                        {dayjs(data?.safetyObservationDate).format("MMMM D, YYYY")}
                      </Typography>
                    </Stack>
                    <Grid sx={{ marginLeft: 1,  marginTop: 1, alignItems: "center" }} size={12}>
                      <Typography
                        sx={{
                          display: "-webkit-box",
                          overflow: "hidden",
                          WebkitBoxOrient: "vertical",
                          WebkitLineClamp: 3
                        }}
                        variant="body1">
                        {data?.description}
                      </Typography>
                      {data?.udFieldsList?.length > 0 &&
                        data?.udFieldsList?.map((item, index) =>
                          item?.value === "true" ? (
                            <Chip
                              key={index}
                              style={{
                                borderRadius: "5px",
                                fontWeight: "bold"
                              }}
                              label={item?.label}
                            />
                          ) : null
                        )}
                    </Grid>
                  </CardContent>
                </ListItemButton>
              </div>
            ) : null}
          </>
        ) : (
          <>
            <div
              style={{
                backgroundColor: "white",
                borderRadius: "10px"
              }}>
              <ListItemButton
                style={{
                  padding: "10px",
                  borderRadius: "10px"
                }}
                onClick={() => setViewModel(true)}>
                <CardContent
                  style={{
                    padding: "0px",
                    width: "100%"
                  }}>
                  <Stack sx={{ display: "flex",  justifyContent: "space-between", alignItems: "center" }}  direction={"row"}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: ".5rem"
                      }}>
                      <Avatar alt={data?.profilePictureUrl} src={data?.profilePictureUrl} />
                      <Typography variant="body2">{data?.userName}</Typography>
                    </div>
                    <Typography
                      style={{
                        color: "grey"
                      }}
                      variant="body2">
                      {dayjs(data?.safetyObservationDate).format("MMMM D, YYYY")}
                    </Typography>
                  </Stack>
                  <Grid sx={{ marginLeft: 1,  marginTop: 1, alignItems: "center" }} size={12} container>
                    <Grid>
                      <LocationOnIcon
                        style={{
                          color: CLIENT_ACCENT_COLOR
                        }}
                      />
                    </Grid>
                    <Grid>
                      <Typography variant="body2" sx={{ color: "text.secondary" }}>
                        {`${data?.clientJobCode} - ${data?.clientJobName}`}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid sx={{ marginLeft: 1,  marginTop: 1, alignItems: "center" }} size={12}>
                    <Typography
                      sx={{
                        display: "-webkit-box",
                        overflow: "hidden",
                        WebkitBoxOrient: "vertical",
                        WebkitLineClamp: 3
                      }}
                      variant="body1">
                      {data?.description}
                    </Typography>
                    {data?.udFieldsList?.length > 0 &&
                      data?.udFieldsList?.map((item, index) =>
                        item?.value === "true" ? (
                          <Chip
                            key={index}
                            style={{
                              borderRadius: "5px",
                              fontWeight: "bold"
                            }}
                            label={item?.label}
                          />
                        ) : null
                      )}
                  </Grid>
                </CardContent>
              </ListItemButton>
            </div>
          </>
        )}
      </Grid>
      <ClientSafetyObservationViewModal
        reLoadData={() => {
          reLoadData();
        }}
        data={data}
        isOpen={viewModal}
        onClose={() => setViewModel(false)}
      />
    </div>
  );
};
